import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class ModerationFilesManagement extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId, upload = false }) {
        if (!upload) {
            return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/files`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/upload_files`;
    }

    static downloadFile({ organizationId, flowId, fileId, url = false }) {
        if (!url) {
            return fetcher.get(`/ticket/organizations/${organizationId}/moderation_flows/${flowId}/files/${fileId}/download`);
        }
        return fetcher.get(`${window.weezConfig.api.apiUrl}${url}`);
    }

    static async uploadFile({ organizationId, flowId, file }) {
        const path = `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/upload_files`;
        const uploadRequest = new UploadRequest(path, file);

        try {
            await uploadRequest.upload();
        } catch (error) {
            return error;
        }
    }
}

class UploadRequest {
    constructor(url, file) {
        this.url = url;
        this.file = file;
        this.headers = {
            Authorization: '',
            'Content-Type': this.file.type,
            'Content-Disposition': `filename=${this.file.name}`
        };
    }

    async upload() {
        let _file = new FormData();
        _file.append('file', this.file);
        const request = await fetcher.post(this.url, {
            data: {
                filename: this.file.name,
                status: 'ready'
            }
        });

        await fetcher.put(request.response.url, {
            body: this.file,
            headers: { ...request.response.headers, ...this.headers },
            auth: false
        });

        await fetcher.patch(`${this.url}/${request.response.id}`, {
            data: {
                status: 'upload'
            }
        });
    }
}
